export default __webpack_public_path__ + "static/media/0.4f66180c.png";